export type LibraryFolder = {
  name: string;
};

export enum FileStatus {
  PUBLISHED = "published",
  ARCHIVED = "archived",
}

export const FILE_STATUS_PARAMS = {
  [FileStatus.PUBLISHED]: {
    folderNameKey: "libraryPage:folderListPublished",
    statusNameKey: "libraryPage:fileStatusPublished",
  },
  [FileStatus.ARCHIVED]: {
    folderNameKey: "libraryPage:folderListArchived",
    statusNameKey: "libraryPage:fileStatusArchived",
  },
};

export type LibraryFile = {
  id: string;
  name: string;
  status: FileStatus;
  folderName: string;
  format: string;
  date: Date;
  url?: string;
};

export enum FileSortKey {
  NAME = "name",
  FOLDER = "folder",
  DATE = "date",
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export const SORT_ARROW: Record<SortDirection, string> = {
  [SortDirection.ASC]: "↑",
  [SortDirection.DESC]: "↓",
};
